import { API_URL_PARTNER } from "@constants/env";
import { apiPartnerToDto } from "@helpers/partner.helper";
import useApiCall from "@hooks/Shared/useApiCall";
import IPartner from "@interfaces/partner";

const useGetPartner = (uuid: string) =>
  useApiCall<IPartner>({
    url: API_URL_PARTNER + uuid,
    transformResponse: (data) =>
      apiPartnerToDto(JSON.parse(data as string) as IPartner),
  });

export default useGetPartner;
